import { Component, OnInit } from '@angular/core';

import { AuthService } from '../../auth/auth.service';
import { ConfigService } from '../../services/config.service';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { filter, take } from 'rxjs';
@Component({
  selector: 'dx-app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
export class AppHeaderComponent implements OnInit {
isUserActive: boolean | null = null;
  constructor(public authService: AuthService,private configService: ConfigService,public auth0Service: Auth0Service,) { }


ngOnInit(): void {
    const tenant = this.configService.config?.tenantDomain;
    if (tenant?.includes('ric')) {
      this.auth0Service.isAuthenticated$.pipe(
        filter(isAuth => isAuth === true),
        take(1)
      ).subscribe(() => {
        this.configService.getUserStatus().pipe(take(1)).subscribe({
          next: (status) => {
            this.isUserActive = status;
          },
          error: () => {
            this.isUserActive = false;
          }
        });
      });
    } else {
      this.isUserActive = true;
    }
  }
}
